import get from "lodash.get";

import { RootState } from "@src/store";
import { getProgressBar, selectedWidget } from "@src/store/slices/widgets";
import { areDeviceMessageBoxDifferent } from "@src/store/slices/widgets/selectors/messageBox";
import { areDeviceProgressBarDifferent } from "@src/store/slices/widgets/selectors/progressBar";
import { areDeviceQuantityButtonsDifferent } from "@src/store/slices/widgets/selectors/quantityButtons";
import {
  isMessageBox,
  isProgressBar,
  isQuantityButtons,
} from "@src/store/slices/widgets/util";

export * from "./messageBox";
export * from "./progressBar";
export * from "./quantityButtons";

export const areDeviceConfigDifferent = (state: RootState) => {
  const widget = selectedWidget(state);
  if (!widget) return false;

  if (isMessageBox(widget)) {
    return areDeviceMessageBoxDifferent(state);
  }
  if (isProgressBar(widget)) {
    return areDeviceProgressBarDifferent(state);
  }
  if (isQuantityButtons(widget)) {
    return areDeviceQuantityButtonsDifferent(state);
  }
  return false;
};

export const getProgressBarWidgetVariable =
  (key: string) => (state: RootState) => {
    return get(getProgressBar(state)?.config?.desktop, key) as unknown;
  };
